<style>
  @import "/css/reset.css";
  @import "/css/common.css";
  @import "/css/paragraph.css";
</style>

<template>
  <v-app>
    <home-app-bar />
    <home-drawer/>
    <home-view />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Index',
  components: {
    HomeAppBar: () => import('@/pages/home/components/HomeAppBar'),
    HomeDrawer: () => import('@/pages/home/components/HomeDrawer'),
    HomeView: () => import('@/pages/home/components/HomeView'),
  },
  computed: {
    ...mapState['menuItemList']
  },
}
</script>

